export default __webpack_public_path__ + "static/media/ambientais-florestais.4746118d.jpg";